var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.25C2.58579 3.25 2.25 3.58579 2.25 4C2.25 4.41421 2.58579 4.75 3 4.75L3 3.25ZM15 4.75C15.4142 4.75 15.75 4.41421 15.75 4C15.75 3.58579 15.4142 3.25 15 3.25V4.75ZM3 4.75L4 4.75L4 3.25L3 3.25L3 4.75ZM3.25 4V15H4.75V4H3.25ZM5 16.75H13V15.25H5V16.75ZM14 4.75L15 4.75V3.25L14 3.25V4.75ZM14.75 15V4H13.25V15H14.75ZM4 4.75L7 4.75V3.25L4 3.25L4 4.75ZM7.75 4V3H6.25V4H7.75ZM8 2.75H10V1.25H8V2.75ZM7 4.75H11V3.25H7V4.75ZM11 4.75L14 4.75V3.25L11 3.25V4.75ZM10.25 3V4H11.75V3H10.25ZM6.75 6.98252V13H8.25V6.98252H6.75ZM11.25 13V6.98252H9.75V13H11.25ZM7.75 3C7.75 2.86193 7.86193 2.75 8 2.75V1.25C7.0335 1.25 6.25 2.0335 6.25 3H7.75ZM13 16.75C13.9665 16.75 14.75 15.9665 14.75 15H13.25C13.25 15.1381 13.1381 15.25 13 15.25V16.75ZM10 2.75C10.1381 2.75 10.25 2.86193 10.25 3H11.75C11.75 2.0335 10.9665 1.25 10 1.25V2.75ZM3.25 15C3.25 15.9665 4.0335 16.75 5 16.75V15.25C4.86193 15.25 4.75 15.1381 4.75 15H3.25Z",
    fill: "#88919A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d62eb2b58ca9ee8cdb26a15908c74965.svg";
export { ForwardRef as ReactComponent };